
import { pathOr, split, last, pipe, replace } from "ramda";

export default {
  props: { field: { type: Object, default: () => {} } },

  computed: {
    provider() {
      return pathOr("", ["provider_name"], this.field);
    },
    mediaUrl() {
      return pathOr("", ["embed_url"], this.field);
    },
    thumbnailUrl() {
      return pathOr("", ["thumbnail_url"], this.field);
    },
    isYoutube() {
      return this.provider.toLowerCase() === "youtube";
    },
    videoId() {
      return pipe(split("/"), last, replace(/watch\?v=/gi, ""))(this.mediaUrl);
    },
  },

  async destroyed() {
    // stop the youtube player if it's currently playing
    const youtubePlayers = await Promise.all(
      Array.from(this.$el.querySelectorAll("lite-youtube")).map(element =>
        element.getYTPlayer()
      )
    );
    youtubePlayers.filter(Boolean).forEach(player => player?.stopVideo());

    // stop the vimeo player if it's currently playing
    const vimeoPlayers = Array.from(this.$el.querySelectorAll("lite-vimeo"))
      .map(element => element.getVimeoPlayer())
      .filter(Boolean);
    await Promise.all(vimeoPlayers.map(player => player?.stop()));
  },
};
